export function generateEncabezado(empresa) {
  return {
    alignment: 'justify',
    columns: [
      {
        stack: [
          { text: empresa.razon_social, style: 'subheader' },
          { text: 'Teléfono: ' + empresa.telefonos.join(', ') },
        ]
      },
    ]
  };
}
